import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalService } from '@spartacus/storefront';

@Component({
  selector: 'sd-remove-payment-modal',
  templateUrl: './remove-payment-modal.component.html',
  styleUrls: ['./remove-payment-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorRemovePaymentModalComponent {
  constructor(private modalService: ModalService) {}

  remove(): void {
    this.modalService.closeActiveModal(true);
  }
}
